import { render } from "./classcatalogue.vue?vue&type=template&id=4707cc57&scoped=true&ts=true"
import script from "./classcatalogue.vue?vue&type=script&lang=ts"
export * from "./classcatalogue.vue?vue&type=script&lang=ts"

import "./classcatalogue.vue?vue&type=style&index=0&id=4707cc57&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4707cc57"]])

export default __exports__